import axios from 'axios'

export default {
  namespaced: true,
  state: {
    topics: [],
    topicCount: 0,
    draftTopic: []
  },
  getters: {
    topics:(state)=>state.topics,
    topicCount:(state)=>state.topicCount,
    draftTopic:(state)=>state.draftTopic
  },
  mutations: {
    get (state, data) {
      state.topics = data.topics
      state.topicCount = data.total_count
    },
    getDraft (state, data) {
      state.draftTopic = data
    }
  },
  actions: {
    async get({ commit }, column) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?sort=' + column)
      commit('get', response.data)
      return response.data
    },
    async getDraft({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/draft')
      commit('getDraft', response.data)
      return response.data
    },
  },
}